import {IonPage, useIonRouter,} from "@ionic/react";
import {FC, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {HeaderComponent} from "../../components";
import {routes} from "../../route/constants";
import {useDispatch} from "react-redux";
import {setShowOnBoardingFlow} from "../../redux/actions/appStatus";
import {useProfile, useUserActionsCheckList} from "../../components/hooks";


export const OnBoardingSetupComplete: FC = () => {
    const { t } = useTranslation();
    const route = useIonRouter();
    const dispatch = useDispatch();


    useEffect(() => {
        const completeOnBoarding = async () => {
            await dispatch(setShowOnBoardingFlow(false));
            route.push(routes.tabResults, "root", "replace");
        };
        completeOnBoarding();
    }, [route, dispatch]);



    return (
        <IonPage className="onboarding-complete-page">
            <HeaderComponent
                titleTestId="setup-complete-header"
                title={t("help.onBoarding.setupComplete")}
            />

        </IonPage>
    );
};